"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OauthClientService", {
    enumerable: true,
    get: function() {
        return OauthClientService;
    }
});
const _common = require("@nestjs/common");
const _dto = require("~/modules/oauth/dto");
const _models = require("~/models");
const _ncError = require("~/helpers/ncError");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let OauthClientService = class OauthClientService {
    async listClients(context, req) {
        var _req_user;
        if (!((_req_user = req.user) == null ? void 0 : _req_user.id)) {
            _ncError.NcError.get(context).badRequest('User not found');
        }
        const clients = await _models.OAuthClient.list(req.user.id);
        return clients.map((client)=>{
            return _extends({}, client, {
                client_secret: undefined
            });
        });
    }
    async getClient(context, { clientId, req }) {
        var _req_user;
        if (!clientId || !((_req_user = req.user) == null ? void 0 : _req_user.id)) {
            _ncError.NcError.get(context).badRequest('Client ID or user not found');
        }
        const client = await _models.OAuthClient.getByClientId(clientId);
        if (!clientId || client.fk_user_id !== req.user.id) {
            _ncError.NcError.get(context).notFound(clientId);
        }
        return client;
    }
    async createClient(context, body, req) {
        const validatedBody = _dto.CreateOAuthClientSchema.safeParse(body);
        if (validatedBody.error) {
            _ncError.NcError.get(context).zodError({
                message: 'Request body is invalid',
                errors: validatedBody.error
            });
        }
        body.fk_user_id = req.user.id;
        return await _models.OAuthClient.insert(body);
    }
    async updateClient(context, { clientId, body, req }) {
        const validatedBody = _dto.UpdateOAuthClientSchema.safeParse(body);
        if (validatedBody.error) {
            _ncError.NcError.get(context).zodError({
                message: 'Request body is invalid',
                errors: validatedBody.error
            });
        }
        const client = await _models.OAuthClient.getByClientId(clientId);
        if (!client || client.fk_user_id !== req.user.id) {
            _ncError.NcError.get(context).apiClientNotFound(clientId);
        }
        return await _models.OAuthClient.update(clientId, body);
    }
    async deleteClient(context, { clientId, req }) {
        await this.getClient(context, {
            clientId,
            req
        });
        await _models.OAuthToken.deleteAllByClient(clientId);
        await _models.OAuthAuthorizationCode.deleteAllByClient(clientId);
        return await _models.OAuthClient.delete(clientId);
    }
    async regenerateClientSecret(context, { clientId, req }) {
        const client = await this.getClient(context, {
            clientId,
            req
        });
        if (!client || client.fk_user_id !== req.user.id) {
            _ncError.NcError.get(context).apiClientNotFound(clientId);
        }
        if (client.client_type !== 'confidential') {
            _ncError.NcError.get(context).badRequest('Only confidential clients can have secrets');
        }
        return await _models.OAuthClient.regenerateSecret(clientId);
    }
};
OauthClientService = _ts_decorate([
    (0, _common.Injectable)()
], OauthClientService);
